import * as React from "react";
import { useEffect } from "react";
import {
  clearParameters,
  removeParameter,
  setDateParameters,
  setParameters,
} from "../redux/global/actions";
import {
  exportMaterialContractsToCSV,
  exportMaterialsToCSV,
} from "../redux/material/actions";
import {
  filterPlaceholderMaterials,
  getPlaceholderMaterialDetails,
  getPlaceholderMaterials,
  getPlaceholderMaterialsBulk,
  sortPlaceholderMaterials,
} from "../redux/material_placeholder/actions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import MultiValueInput from "../inputs/multiValueInput";
import {
  Box,
  Fab,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Tabs,
  Tab,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import "./PlaceholderMaterials.css";
import SearchDateInput from "../inputs/searchDateInput";
import Title from "./Title";
import { Table } from "react-bootstrap";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DateInput from "../inputs/dateInput";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import {
  downloadCSV,
  downloadJSON,
  extractUserInfoFromToken,
  getLocalStorageSAMLToken,
} from "../utils";
import SingleSelector from "../inputs/singleSelector";
import MultiSelector from "../inputs/MultiSelector";

export default function PlaceholderMaterials() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessedUrlParams = React.useRef(false);

  const queryParameters = useSelector(
    (state) => state?.parameters?.placeholderMaterials,
  );

  const [currentSerialNumbers, setCurrentSerialNumbers] = React.useState();
  const [currentProductReferences, setCurrentProductReferences] =
    React.useState();
  const [currentSoldTo, setCurrentSoldTo] = React.useState();
  const [currentBusinessPartnerId, setCurrentBusinessPartnerId] =
    React.useState();
  const [currentEndUser, setCurrentEndUser] = React.useState();
  const [currentPartNumber, setCurrentPartNumber] = React.useState();

  const [filterSerialNumbers, setFilterSerialNumbers] = React.useState([]);
  const [filterPartNumbers, setFilterPartNumbers] = React.useState([]);
  const [filterSoldTos, setFilterSoldTos] = React.useState([]);
  const [filterBusinessPartners, setFilterBusinessPartners] = React.useState(
    [],
  );
  const [filterOrderIds, setFilterOrderIds] = React.useState([]);
  const [filterOrderLines, setFilterOrderLines] = React.useState([]);
  const [filterCreationDateStart, setFilterCreationDateStart] =
    React.useState();
  const [filterCreationDateEnd, setFilterCreationDateEnd] = React.useState();
  const [filterModificationDateStart, setFilterModificationDateStart] =
    React.useState();
  const [filterModificationDateEnd, setFilterModificationDateEnd] =
    React.useState();
  const [selectedTab, setSelectedTab] = React.useState(0);

  const tabs = [
    {
      label: "Placeholder Materials",
      filters: [
        "serialNumbers",
        "productReferences",
        "soldTos",
        "businessPartnerIds",
        "endUser",
        "partNumber",
        "isNaaS",
        "creationDate",
      ],
    },
    {
      label: "Monitoring Material Swap",
      filters: ["swapStatus"],
    },
  ];

  const handleExecuteSearch = () => {
    let queryObject = {
      limit: 100,
    };
    const currentFilters = tabs[selectedTab].filters;
    if (
      currentFilters.includes("serialNumbers") &&
      queryParameters?.serialNumbers
    ) {
      queryObject.serial_number = queryParameters?.serialNumbers;
    }
    if (
      currentFilters.includes("productReferences") &&
      queryParameters?.productReferences
    ) {
      queryObject.bundle_reference = queryParameters?.productReferences;
    }
    if (currentFilters.includes("soldTos") && queryParameters?.soldTos) {
      queryObject.sold_to = queryParameters?.soldTos;
    }
    if (
      currentFilters.includes("businessPartnerIds") &&
      queryParameters?.businessPartnerIds
    ) {
      queryObject.business_partner = queryParameters?.businessPartnerIds;
    }
    if (currentFilters.includes("endUser") && queryParameters?.endUser) {
      queryObject.end_user = queryParameters?.endUser;
    }
    if (currentFilters.includes("partNumber") && queryParameters?.partNumber) {
      queryObject.part_number = queryParameters?.partNumber;
    }
    if (currentFilters.includes("swapStatus") && queryParameters?.swapStatus) {
      queryObject.swap_status = queryParameters?.swapStatus;
    }
    if (
      currentFilters.includes("creationDate") &&
      queryParameters?.creationDateStart &&
      queryParameters?.creationDateEnd
    ) {
      queryObject.creation_date_from = queryParameters?.creationDateStart;
      queryObject.creation_date_to = queryParameters?.creationDateEnd;
    }
    dispatch(getPlaceholderMaterials(queryObject));
  };

  const handleExecuteBulkSearch = () => {
    let queryObject = {};
    const currentFilters = tabs[selectedTab].filters;
    if (
      currentFilters.includes("serialNumbers") &&
      queryParameters?.serialNumbers
    ) {
      queryObject.serial_number = queryParameters?.serialNumbers;
    }
    if (
      currentFilters.includes("productReferences") &&
      queryParameters?.productReferences
    ) {
      queryObject.bundle_reference = queryParameters?.productReferences;
    }
    if (currentFilters.includes("soldTos") && queryParameters?.soldTos) {
      queryObject.sold_to = queryParameters?.soldTos;
    }
    if (
      currentFilters.includes("businessPartnerIds") &&
      queryParameters?.businessPartnerIds
    ) {
      queryObject.business_partner_id = queryParameters?.businessPartnerIds;
    }
    if (currentFilters.includes("endUser") && queryParameters?.endUser) {
      queryObject.end_user = queryParameters?.endUser;
    }
    if (currentFilters.includes("isNaaS") && queryParameters?.isNaaS) {
      queryObject.is_naas = queryParameters?.isNaaS;
    }
    if (currentFilters.includes("swapStatus") && queryParameters?.swapStatus) {
      queryObject.swap_status = queryParameters?.swapStatus;
    }
    if (
      currentFilters.includes("creationDate") &&
      queryParameters?.creationDateStart &&
      queryParameters?.creationDateEnd
    ) {
      queryObject.creation_date_from = queryParameters?.creationDateStart;
      queryObject.creation_date_to = queryParameters?.creationDateEnd;
    }
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(getPlaceholderMaterialsBulk(queryObject));
  };

  const handleExecuteFilter = () => {
    let filterObject = {};
    if (filterSerialNumbers?.length > 0) {
      filterObject.serialNumbers = [filterSerialNumbers];
    }
    if (filterBusinessPartners?.length > 0) {
      filterObject.businessPartners = [filterBusinessPartners];
    }
    if (filterSoldTos?.length > 0) {
      filterObject.soldTos = [filterSoldTos];
    }
    if (filterPartNumbers?.length > 0) {
      filterObject.partNumbers = [filterPartNumbers];
    }
    if (filterOrderLines?.length > 0) {
      filterObject.orderLines = [filterOrderLines];
    }
    if (filterOrderIds?.length > 0) {
      filterObject.orderIds = [filterOrderIds];
    }
    if (filterCreationDateStart) {
      filterObject.filterCreationDateStart = filterCreationDateStart;
    }
    if (filterCreationDateEnd) {
      filterObject.filterCreationDateEnd = filterCreationDateEnd;
    }
    dispatch(filterPlaceholderMaterials(filterObject));
  };

  useEffect(() => {
    handleExecuteFilter();
  }, [
    filterSerialNumbers,
    filterPartNumbers,
    filterSoldTos,
    filterBusinessPartners,
    filterOrderIds,
    filterOrderLines,
    filterCreationDateStart,
    filterCreationDateEnd,
    filterModificationDateStart,
    filterModificationDateEnd,
  ]);

  // Reset the URL processing flag when the URL actually changes
  useEffect(() => {
    hasProcessedUrlParams.current = false;
  }, [searchParams.toString()]);

  useEffect(() => {
    if (hasProcessedUrlParams.current) return;

    const businessPartnerId = searchParams.get("businessPartnerId");
    if (businessPartnerId) {
      const businessPartnerIds = businessPartnerId
        .split(",")
        .map((id) => id.trim());

      // Check if these business partner IDs are already in the Redux state
      const existingBusinessPartnerIds =
        queryParameters?.businessPartnerIds || [];
      const newBusinessPartnerIds = businessPartnerIds.filter(
        (id) => !existingBusinessPartnerIds.includes(id),
      );

      if (newBusinessPartnerIds.length > 0) {
        setCurrentBusinessPartnerId(businessPartnerIds.join(", "));
        dispatch(
          setParameters({
            placeholderMaterials: { businessPartnerIds: newBusinessPartnerIds },
          }),
        );
        hasProcessedUrlParams.current = true;

        setTimeout(() => {
          handleExecuteSearch();
        }, 100);
      } else {
        // If business partner IDs already exist, just update the display
        setCurrentBusinessPartnerId(existingBusinessPartnerIds.join(", "));
        hasProcessedUrlParams.current = true;
      }
    }
  }, [searchParams, dispatch, queryParameters]);

  const handleDeleteSerialNumber = (chipToDelete) => () => {
    dispatch(
      removeParameter({
        placeholderMaterials: { serialNumbers: [chipToDelete] },
      }),
    );
  };
  const handleClearSerialNumbers = () => {
    dispatch(clearParameters({ placeholderMaterials: "serialNumbers" }));
  };
  const handleDeleteProductReference = (chipToDelete) => () => {
    dispatch(
      removeParameter({
        placeholderMaterials: { productReferences: [chipToDelete] },
      }),
    );
  };
  const handleClearProductReferences = () => {
    dispatch(clearParameters({ placeholderMaterials: "productReferences" }));
  };
  const handleDeleteSoldTo = (chipToDelete) => () => {
    dispatch(
      removeParameter({ placeholderMaterials: { soldTos: [chipToDelete] } }),
    );
  };
  const handleClearSoldTos = () => {
    dispatch(clearParameters({ placeholderMaterials: "soldTos" }));
  };
  const handleDeleteBusinessPartnerId = (chipToDelete) => () => {
    dispatch(
      removeParameter({
        placeholderMaterials: { businessPartnerIds: [chipToDelete] },
      }),
    );
  };
  const handleClearBusinessPartnerIds = () => {
    dispatch(clearParameters({ placeholderMaterials: "businessPartnerIds" }));
  };
  const handleDeleteEndUser = (chipToDelete) => () => {
    dispatch(
      removeParameter({ placeholderMaterials: { endUser: [chipToDelete] } }),
    );
  };
  const handleClearEndUser = () => {
    dispatch(clearParameters({ placeholderMaterials: "endUser" }));
  };
  const handleDeletePartNumber = (chipToDelete) => () => {
    dispatch(
      removeParameter({ placeholderMaterials: { partNumber: [chipToDelete] } }),
    );
  };
  const handleClearPartNumber = () => {
    dispatch(clearParameters({ placeholderMaterials: "partNumber" }));
  };
  const handleDeleteIsNaaS = (chipToDelete) => () => {
    dispatch(
      removeParameter({ placeholderMaterials: { isNaaS: [chipToDelete] } }),
    );
  };
  const handleClearIsNaaS = () => {
    dispatch(clearParameters({ placeholderMaterials: "isNaaS" }));
  };
  const handleDeleteSwapStatus = (chipToDelete) => () => {
    dispatch(
      removeParameter({ placeholderMaterials: { swapStatus: [chipToDelete] } }),
    );
  };
  const handleClearSwapStatus = () => {
    dispatch(clearParameters({ placeholderMaterials: "swapStatus" }));
  };
  const handleExport = (materials, format = "csv") => {
    const fields = [
      { name: "serial_number" },
      { name: "status" },
      { name: "inactive_reason" },
      { name: "order_id" },
      { name: "part_number" },
      { name: "business_partner", value: "business_partner_company_id" },
      { name: "support_partner", value: "support_partner_company_id" },
      { name: "end_user", value: "end_user_company_id" },
      { name: "children" },
    ];
    if (format === "csv") {
      downloadCSV(fields, "material_export", ",", materials);
    } else {
      downloadJSON(fields, "material_export", materials);
    }
  };

  const handleExportContractsToCSV = (materials) => {
    dispatch(exportMaterialContractsToCSV(materials, "placeholder"));
  };

  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);
  const [openBulkMessage, setOpenBulkMessage] = React.useState(false);

  const placeholderMaterials = useSelector((state) => {
    if (state.filteredPlaceholderMaterials) {
      return state.filteredPlaceholderMaterials.map((serialNumber) => {
        return {
          modification_date: serialNumber.modification_date,
          part_number: serialNumber.part_number,
          inactive_reason: serialNumber.inactive_reason,
          status: serialNumber.status,
          creation_note: serialNumber.creation_note,
          comments: serialNumber.comments,
          serial_number: serialNumber.serial_number,
          sn_type: serialNumber.sn_type,
          description: serialNumber.description,
          source_time: serialNumber.source_time,
          type: serialNumber.type,
          creation_date: serialNumber.creation_date,
          sold_to: serialNumber?.sold_to?.applicant_id,
          order_line: serialNumber?.order?.order_line,
          order_id: serialNumber?.order?.order_id,
          purchase_order: serialNumber?.order?.purchase_order,
          end_user_source: serialNumber?.end_user?.source,
          end_user_company_id: serialNumber?.end_user?.company_id,
          business_partner_source: serialNumber?.business_partner?.source,
          business_partner_company_id:
            serialNumber?.business_partner?.company_id,
          support_partner_source: serialNumber?.support_partner?.source,
          support_partner_company_id: serialNumber?.support_partner?.company_id,
          placeholder_id: serialNumber?.placeholder_id,
        };
      });
    } else return [];
  });

  const [sortDirection, setSortDirection] = React.useState("");
  const [sortParameter, setSortParameter] = React.useState("");

  const handleSortPlaceholderMaterials = (sortParameter) => {
    setSortParameter(sortParameter);
    if (sortDirection === "") {
      setSortDirection("ascending");
      dispatch(sortPlaceholderMaterials(sortParameter, "ascending"));
    } else if (sortDirection === "ascending") {
      setSortDirection("descending");
      dispatch(sortPlaceholderMaterials(sortParameter, "descending"));
    } else {
      setSortDirection("ascending");
      dispatch(sortPlaceholderMaterials(sortParameter, "ascending"));
    }
  };

  function handleSelectPlaceholderMaterial(placeholder_id, orderId, orderLine) {
    let parts = placeholder_id.split("#");

    let serial_number = parts[0];
    let business_partner = parts[1];
    dispatch(
      getPlaceholderMaterialDetails({
        serial_number: serial_number,
        business_partner: business_partner,
        order_id: orderId,
        order_line: orderLine,
      }),
    );
    navigate(
      "/placeholdermaterials/details/" + serial_number + "/" + business_partner,
    );
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(document.getElementById("menuAnchor"));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterDescription =
    "Add filters to the list of results, and export the filtered list to CSV";

  const handleKeydown = (event) => {
    if (event.key == "Enter") {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch();
      }, 0);
    }
  };

  const isNaaSValue = ["True", "False"];
  const swapStatusValues = ["Replaced - HWS In"];

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return (
    <React.Fragment>
      <Modal
        open={openBulkMessage}
        style={{
          textAlign: "center",
          paddingTop: "45vh",
        }}
      >
        <>
          <Typography style={{ color: "white" }}>
            Your query has been sent. You can follow the status in the Bulk
            Report page or wait for the Rainbow message that will announce the
            end of the export.
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => {
                  setOpenBulkMessage(false);
                }}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <Modal
        open={openBulkConfirmation}
        style={{
          textAlign: "center",
          paddingTop: "45vh",
        }}
      >
        <>
          <Typography style={{ color: "white" }}>
            This query could take a few minutes, are you sure you want to
            continue?
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => {
                  handleExecuteBulkSearch();
                  setOpenBulkConfirmation(false);
                  setOpenBulkMessage(true);
                }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item style={{ width: "7%" }} />
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => setOpenBulkConfirmation(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        aria-label="filter tabs"
      >
        {tabs.map((tab, index) => (
          <Tab label={tab.label} key={index} />
        ))}
      </Tabs>

      <div role="tabpanel" hidden={selectedTab !== 0}>
        {selectedTab === 0 && (
          <Box sx={{ p: 3 }}>
            <MultiValueInput
              setCurrentParam={setCurrentSerialNumbers}
              setQueryParams={setParameters}
              currentParam={currentSerialNumbers}
              queryParams={queryParameters?.serialNumbers}
              handleDelete={handleDeleteSerialNumber}
              handleClear={handleClearSerialNumbers}
              label="Serial Number"
              family="placeholderMaterials"
              type="serialNumbers"
            />
            <MultiValueInput
              setCurrentParam={setCurrentProductReferences}
              setQueryParams={setParameters}
              currentParam={currentProductReferences}
              queryParams={queryParameters?.productReferences}
              handleDelete={handleDeleteProductReference}
              handleClear={handleClearProductReferences}
              label="Product Reference"
              family="placeholderMaterials"
              type="productReferences"
            />
            <MultiValueInput
              setCurrentParam={setCurrentSoldTo}
              setQueryParams={setParameters}
              currentParam={currentSoldTo}
              queryParams={queryParameters?.soldTos}
              handleDelete={handleDeleteSoldTo}
              handleClear={handleClearSoldTos}
              label="Sold To"
              family="placeholderMaterials"
              type="soldTos"
            />
            <MultiValueInput
              setCurrentParam={setCurrentBusinessPartnerId}
              setQueryParams={setParameters}
              currentParam={currentBusinessPartnerId}
              queryParams={queryParameters?.businessPartnerIds}
              handleDelete={handleDeleteBusinessPartnerId}
              handleClear={handleClearBusinessPartnerIds}
              label="Business Partner ID"
              family="placeholderMaterials"
              type="businessPartnerIds"
            />
            <MultiValueInput
              setCurrentParam={setCurrentEndUser}
              setQueryParams={setParameters}
              currentParam={currentEndUser}
              queryParams={queryParameters?.endUser}
              handleDelete={handleDeleteEndUser}
              handleClear={handleClearEndUser}
              label="End User"
              family="placeholderMaterials"
              type="endUser"
            />
            <MultiValueInput
              setCurrentParam={setCurrentPartNumber}
              setQueryParams={setParameters}
              currentParam={currentPartNumber}
              queryParams={queryParameters?.partNumber}
              handleDelete={handleDeletePartNumber}
              handleClear={handleClearPartNumber}
              label="Part Number"
              family="placeholderMaterials"
              type="partNumber"
            />
            <SingleSelector
              setQueryParams={setParameters}
              queryParams={queryParameters?.isNaaS}
              handleDelete={handleDeleteIsNaaS}
              handleClear={handleClearIsNaaS}
              label="Is NaaS"
              family="placeholderMaterials"
              type="isNaaS"
              options={isNaaSValue}
            />
            <Grid>
              <SearchDateInput
                title={"Creation Date"}
                setFilterDate={setDateParameters}
                family="placeholderMaterials"
                type="creationDateStart"
                type2="creationDateEnd"
              />
            </Grid>
          </Box>
        )}
      </div>

      <div role="tabpanel" hidden={selectedTab !== 1}>
        {selectedTab === 1 && (
          <Box sx={{ p: 3 }}>
            <MultiSelector
              setQueryParams={setParameters}
              queryParams={queryParameters?.swapStatus}
              handleDelete={handleDeleteSwapStatus}
              handleClear={handleClearSwapStatus}
              label="Swap Status"
              family="placeholderMaterials"
              type="swapStatus"
              options={swapStatusValues}
            />
          </Box>
        )}
      </div>

      <Grid
        container
        style={{
          justifyContent: "center",
        }}
      >
        <Grid item>
          <Button
            variant="contained"
            onClick={handleExecuteSearch}
            style={{ width: "15vw" }}
          >
            Search
          </Button>
        </Grid>
        <div style={{ paddingLeft: "0.2%" }} />
        {selectedTab === 0 && (
          <Grid item>
            <Button
              variant="contained"
              onClick={() => setOpenBulkConfirmation(true)}
              style={{ width: "15vw" }}
            >
              Bulk Export
            </Button>
          </Grid>
        )}
      </Grid>
      <Title>Materials</Title>
      <Typography>
        {placeholderMaterials?.length
          ? placeholderMaterials?.length === 100
            ? placeholderMaterials?.length +
              " results, use bulk export for more"
            : placeholderMaterials?.length + " results"
          : null}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Serial Number"
                    variant="standard"
                    onChange={(e) => {
                      setFilterSerialNumbers(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() =>
                    handleSortPlaceholderMaterials("serial_number")
                  }
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "serial_number" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "serial_number" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell
              onClick={() => handleSortPlaceholderMaterials("creation_date")}
            >
              <Grid container className="headercontainer">
                <Grid item>Creation Date</Grid>
                <Grid item>
                  {sortDirection === "ascending" &&
                  sortParameter === "creation_date" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "creation_date" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell
              onClick={() =>
                handleSortPlaceholderMaterials("modification_date")
              }
            >
              <Grid container className="headercontainer">
                <Grid item>Modification Date</Grid>
                <Grid item>
                  {sortDirection === "ascending" &&
                  sortParameter === "modification_date" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "modification_date" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>

            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Part Number"
                    variant="standard"
                    onChange={(e) => {
                      setFilterPartNumbers(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortPlaceholderMaterials("part_number")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "part_number" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "part_number" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>

            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Sold To"
                    variant="standard"
                    onChange={(e) => {
                      setFilterSoldTos(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() =>
                    handleSortPlaceholderMaterials("sold_to.applicant_id")
                  }
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "sold_to.applicant_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "sold_to.applicant_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>

            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Business Partner"
                    variant="standard"
                    onChange={(e) => {
                      setFilterBusinessPartners(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() =>
                    handleSortPlaceholderMaterials(
                      "business_partner.company_id",
                    )
                  }
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "business_partner.company_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "business_partner.company_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Order Id"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderIds(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() =>
                    handleSortPlaceholderMaterials("order.order_id")
                  }
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "order.order_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order.order_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Order Line"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderLines(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() =>
                    handleSortPlaceholderMaterials("order.order_line")
                  }
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "order.order_line" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "order.order_line" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Is NaaS"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderLines(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortPlaceholderMaterials("is_naas")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "is_naas" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "is_naas" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {placeholderMaterials.map((row, i) => (
            <TableRow
              hover
              key={row?.serial_number + i}
              onClick={() => {
                handleSelectPlaceholderMaterial(
                  row?.placeholder_id,
                  row?.order_id,
                  row?.order_line,
                );
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <TableCell>{row?.serial_number}</TableCell>
              <TableCell>{row?.creation_date}</TableCell>
              <TableCell>{row?.modification_date}</TableCell>
              <TableCell>{row?.part_number}</TableCell>
              <TableCell>{row?.sold_to}</TableCell>
              <TableCell>{row?.business_partner_company_id}</TableCell>
              <TableCell>{row?.order_id}</TableCell>
              <TableCell>{row?.order_line}</TableCell>
              <TableCell>{row?.is_naas}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Tooltip
        title={<Typography fontSize={17}>{filterDescription}</Typography>}
      >
        <Fab
          style={{
            position: "absolute",
            right: 10,
            bottom: 10,
            backgroundColor: "#6b469e",
            color: "white",
            height: "5em",
            width: "5em",
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <div
            id="menuAnchor"
            style={{
              position: "relative",
              bottom: 500,
              right: 250,
            }}
          ></div>
          <FileDownloadIcon
            fontSize="large"
            style={{ height: "70%", width: "70%" }}
          />
        </Fab>
      </Tooltip>
      <div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem>
            <TextField
              label="Serial Number"
              onChange={(e) => {
                setFilterSerialNumbers(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <Grid>
              <div>Creation Date</div>
              <DateInput
                setFilterDateStart={setFilterCreationDateStart}
                setFilterDateEnd={setFilterCreationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem>
            <Grid>
              <div>Modification Date</div>
              <DateInput
                setFilterDateStart={setFilterModificationDateStart}
                setFilterDateEnd={setFilterModificationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem>
            <TextField
              label="Part Number"
              onChange={(e) => {
                setFilterPartNumbers(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Sold To"
              onChange={(e) => {
                setFilterSoldTos(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Business Partner"
              onChange={(e) => {
                setFilterBusinessPartners(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Order Id"
              onChange={(e) => {
                setFilterOrderIds(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Order Line"
              onChange={(e) => {
                setFilterOrderLines(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem hover="false">
            <Button
              variant="contained"
              onClick={() => {
                handleExport(placeholderMaterials, "csv");
              }}
            >
              Export materials as CSV
            </Button>
          </MenuItem>
          <MenuItem hover="false">
            <Button
              variant="contained"
              onClick={() => {
                handleExport(placeholderMaterials, "json");
              }}
            >
              Export materials as JSON
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              variant="contained"
              onClick={() => {
                handleExportContractsToCSV(placeholderMaterials);
              }}
            >
              Export contracts
            </Button>
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
}
